import useAPI from "./useAPI";
import useCompany from "./useCompany";

export default function useSmartContracts() {
  const api = useAPI();
  const { activeCompany: company } = useCompany();

  const adminSmartContracts = async () => {
    return await api.getAdminSmartContracts();
  };
  const adminSmartContractById = async (contractId) => {
    const contracts = await api.getAdminSmartContracts();
    return contracts.find((contract) => contract.id === contractId);
  };
  const adminCreateSmartContract = async (contractData) => {
    return await api.createAdminSmartContract(contractData);
  };
  const adminUpdateSmartContract = async (contractId, contractData) => {
    return await api.updateAdminSmartContract(contractId, contractData);
  };
  const adminDeleteSmartContract = async (contractId) => {
    return await api.deleteAdminSmartContract(contractId);
  };

  const getCompanySmartContracts = async () => {
    return await api.getCompanySmartContracts(company?.id);
  };
  const addSmartContractToCompany = async (companyId, contractId, order) => {
    return await api.addSmartContractToCompany(companyId, contractId, order);
  };
  const updateCompanySmartContract = async (companyId, contractId, order) => {
    return await api.updateCompanySmartContract(companyId, contractId, order);
  };
  const removeSmartContractFromCompany = async (companyId, contractId) => {
    return await api.removeSmartContractFromCompany(companyId, contractId);
  };

  return {
    adminSmartContracts,
    adminSmartContractById,
    adminCreateSmartContract,
    adminUpdateSmartContract,
    adminDeleteSmartContract,
    getCompanySmartContracts,
    addSmartContractToCompany,
    updateCompanySmartContract,
    removeSmartContractFromCompany,
  };
}